import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Modal, Icon, Radio, Input } from 'semantic-ui-react';
import { PopupTextCell } from 'Common/GridHelper';
import { connect } from 'react-redux';

import * as PagingActions from 'State/paging/actions';
import * as PagingConstants from 'State/paging/constants';

import { IngredientTable } from './IngredientTable';
import { IngredientFieldEnum as Fields } from 'Common/FieldEnum';
import 'Styles/pages/managemenu/manageMenuModal.less';

class IngredientTableModal extends Component {
  static propTypes = {
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
    headerTitle: PropTypes.string.isRequired,
    onAddIngredient: PropTypes.func,

    setPageNumber: PropTypes.func.isRequired,
    onSearchParametersChange: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    setSortColumn: PropTypes.func.isRequired,

    select: PropTypes.bool,
    selected: PropTypes.object,
    onSelectIngredient: PropTypes.func,
    openIngredientModal: PropTypes.func,

    disableViewEdit: PropTypes.bool,
    hideInactiveToggle: PropTypes.bool,
  };

  static defaultProps = {
    onAddIngredient: () => {},
    searchParameters: {
      Search: '',
      ShowInvLinked: false,
      ShowInactive: false,
      UsedOnCycleMenu: false,
    },
  };

  onSearchTextChange = (e) => {
    const {
      target: { value },
    } = e;
    const { searchParameters, onSearchParametersChange, setPageNumber } =
      this.props;
    const updatedSearchParameters = {
      ...searchParameters,
      Search: value,
    };
    onSearchParametersChange(updatedSearchParameters);
    setPageNumber(1);
  };

  setToggle = (field) => (e, data) => {
    const { searchParameters, onSearchParametersChange } = this.props;
    const updatedSearchParameters = {
      ...searchParameters,
      [field]: data.checked,
    };
    onSearchParametersChange(updatedSearchParameters);
  };

  onAddIngredient = (ingredient) => {
    this.props.onAddIngredient(ingredient);
  };

  onSelectIngredient = (ingredient) => {
    this.props.onSelectIngredient(ingredient);
  };

  onPageChange = (page) => {
    this.props.setPageNumber(page + 1);
  };

  onPageSizeChange = (pageSize, page) => {
    this.props.setPageSize(pageSize, 1);
  };

  onSortedChange = (sorted) => {
    this.props.setSortColumn(sorted);
  };

  onFilteredChange = (filtered) => {
    this.props.setFilter(filtered);
  };

  addIngredientCell = ({ row }) => {
    return (
      <Icon
        link
        onClick={() => this.onAddIngredient(row._original)}
        name="add"
        color="green"
        size="large"
      />
    );
  };

  additionalColumns = [
    {
      id: 'AddIngredient',
      Header: '',
      Cell: this.addIngredientCell,
      sortable: false,
      filterable: false,
      resizable: false,
      show: true,
      visibility: true,
      width: 40,
      style: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    {
      Header: 'Allergens',
      accessor: Fields.Allergens,
      style: {
        textAlign: 'left',
      },
      Cell: ({ original }) => {
        const value = original[Fields.Allergens];
        return <PopupTextCell text={value} />;
      },
      sortable: true,
      resizable: true,
      visibility: true,
      show: false,
      filterable: true,
      addToEnd: true,
    },
    {
      Header: 'Attributes',
      accessor: Fields.Attributes,
      style: {
        textAlign: 'left',
      },
      Cell: ({ original }) => {
        const value = original[Fields.Attributes];
        return <PopupTextCell text={value} />;
      },
      sortable: true,
      resizable: true,
      visibility: true,
      show: false,
      filterable: true,
      addToEnd: true,
    },
  ];

  render() {
    const {
      headerTitle,
      modalProps,
      searchParameters,
      disableViewEdit,
      hideInactiveToggle,
      openIngredientModal,
      ...proxiedProps // props from withIngredientApi
    } = this.props;

    const { Search, ShowInvLinked, ShowInactive } = searchParameters;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header ">
          {headerTitle}
          <Icon
            className="cursor-pointer"
            name="close"
            onClick={modalProps.onClose}
          />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <Grid padded>
            <Grid.Row>
              <Grid.Column width="8" verticalAlign="middle">
                <Input
                  placeholder="Smartest Lunchroom Search"
                  fluid
                  icon={<Icon name="search" />}
                  iconPosition="left"
                  onChange={this.onSearchTextChange}
                  value={Search}
                />
              </Grid.Column>
              <Grid.Column width="3" verticalAlign="middle">
                <Radio
                  onChange={this.setToggle('ShowInvLinked')}
                  toggle
                  checked={ShowInvLinked}
                  label="Inventory Linked"
                />
              </Grid.Column>
              {!hideInactiveToggle && (
                <Grid.Column width="5" verticalAlign="middle">
                  <Radio
                    onChange={this.setToggle('ShowInactive')}
                    toggle
                    checked={ShowInactive}
                    label="Show Inactive / Deactivated Only"
                  />
                </Grid.Column>
              )}
            </Grid.Row>
            <Grid.Row>
              <IngredientTable
                {...proxiedProps}
                additionalColumns={this.additionalColumns}
                manual={true}
                controlledPaging={true}
                openItemInModal={true}
                closeTableModal={modalProps.onClose}
                hasSelectAllColumn={true}
                onSortedChange={this.onSortedChange}
                onFilteredChange={this.onFilteredChange}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
                disableViewEdit={disableViewEdit}
                openIngredientModal={openIngredientModal}
              />
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

const secondaryPagingActions = PagingActions.commonStatePagingActions(
  PagingConstants.secondaryPrefix
);
const mapDispatchToProps = {
  setPageNumber: secondaryPagingActions.setPageNumber,
  setPageSize: secondaryPagingActions.setPageSize,
  setSortColumn: secondaryPagingActions.setSortColumn,
  setFilter: secondaryPagingActions.setFilter,
};

IngredientTableModal = connect(null, mapDispatchToProps)(IngredientTableModal);

export { IngredientTableModal };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/components/IngredientTableModal.js